import { useMarketingLang } from "../i18n.jsx";

export default function InteractiveFilter() {
  const { t } = useMarketingLang();
  return (
    <section id="try" className="section-y">
      <div className="container-page">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <p className="eyebrow mb-4">{t('interactiveFilter.eyebrow')}</p>
            <h2 className="h-section max-w-[680px] text-ink">
              {t('interactiveFilter.title')}
            </h2>
          </div>
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/45">
            {t('interactiveFilter.liveDemo')}
          </p>
        </div>

        <div className="rounded-2xl overflow-hidden border-hairline-base bg-bg-card">
          <iframe
            src="/demo"
            className="w-full block"
            style={{ height: 780, border: 0 }}
            allow="fullscreen"
            title="SEIDR site finder demo"
          />
        </div>
      </div>
    </section>
  );
}
